<template>
  <div class="point-event-info">
    <header class="title">
      <h5>{{ $t(`nightToCoupon.title`) }}</h5>
    </header>
    <div class="main">
      <section class="main__rule">
        <p class="section__title">{{ $t(`nightToCoupon.rule`) }}</p>
        <ol class="rule__content">
          <template v-for="i in Object.keys($t('nightToCoupon.ruleContent'))">
            <li :key="i">{{ $t(`nightToCoupon.ruleContent[${i}]`) }}</li>
          </template>
        </ol>
      </section>
      <section class="main__flow">
        <p class="section__title">{{ $t(`nightToCoupon.flow`) }}</p>
        <div class="card">
          <div class="card__image"><img src="@/assets/images/points/info-1.svg" alt=""></div>
          <div class="card__content">
            <h3>{{ $t(`nightToCoupon.step.0.title`) }}</h3>
            <p>{{ $t(`nightToCoupon.step.0.desc`) }}</p>
          </div>
        </div>
        <div class="card">
          <div class="card__image"><img src="@/assets/images/points/info-2.svg" alt=""></div>
          <div class="card__content">
            <h3>{{ $t(`nightToCoupon.step.1.title`) }}</h3>
            <p>{{ $t(`nightToCoupon.step.1.desc`) }}</p>
          </div>
        </div>
        <div class="card">
          <div class="card__image"><img src="@/assets/images/points/info-3.svg" alt=""></div>
          <div class="card__content">
            <h3>{{ $t(`nightToCoupon.step.2.title`) }}</h3>
            <p>{{ $t(`nightToCoupon.step.2.desc`) }}</p>
          </div>
        </div>
      </section>
    </div>
    <div class="point-event-info__btn my-40">
      <!-- <a class="btn btn-blue btn-solid m-auto no-underline" :href="rulesUrl" target="_blank">{{ $t(`nightToCoupon.detailRule`) }}</a> -->
      <button class="btn btn-blue btn-solid m-auto no-underline" @click='onClickOpenPdf' target="_blank">{{ $t(`nightToCoupon.detailRule`) }}</button>
    </div>
  </div>
</template>

<script>
import crypto from '@/utils/crypto'
export default {
  name: 'pointEventInfo',
  computed: {
    rulesUrl: function () {
      return process.env.VUE_APP_GIFT_RULES_URL
    }
  },
  methods: {
    onClickOpenPdf: function () {
      const pdf = { title: this.$t(`nightToCoupon.detailRule`), url: this.rulesUrl }
      const routeData = this.$router.resolve({
        name: 'PdfViewer',
        params: {
          data: crypto.encode(pdf)
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
.point-event-info
  width: 60%
  min-width: 350px
  margin: auto
  &__btn
    display: flex
    justify-content: space-around
.title
  @apply border-b border-grey-lighter my-16 py-16
  line-height: 1.5
  > h5
    font-weight: 600
.section__title
  @apply text-grey-dark mt-24 mb-8
.rule__content, .card__content
  @apply text-grey-darker
  line-height: 1.5
  white-space: pre-wrap
.rule__content
  padding-inline-start: 1rem
  >li
    @apply mt-8
section + section
  @apply mt-40
.card
  @apply flex
  &__image
    width: 60px
    height: 60px
    >img
      max-width: unset
  &__content
    @apply ml-24
    >h3
      font-weight: 600
  + .card
    @apply my-40
</style>
